<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>服务管理</el-breadcrumb-item>
      <el-breadcrumb-item>评价管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="80px"
        >
          <el-form-item label="客户" prop="customer_id">
            <customer-select
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>
          <el-form-item label="NCR编号" prop="number">
            <el-input
              size="small"
              v-model="filter.number"
              @keyup.enter.native="requestServiceQuest"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="ServiceOrder" prop="service_order_number">
            <el-input
              size="small"
              v-model="filter.service_order_number"
              @keyup.enter.native="requestServiceQuest"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否评价" prop="is_comment">
            <el-select
              size="small"
              v-model="filter.is_comment"
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option :value="0" label="不限"></el-option>
              <el-option :value="1" label="已评价"></el-option>
              <el-option :value="2" label="未评价"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送日期" prop="date">
            <el-date-picker
              style="width: 360px"
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestServiceQuest()"
            >查询</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header">
        <file-button
          style="float: right"
          obj="service_quest_comment"
          :filter="filter"
          :importButton="false"
          class="mobile-hide"
        ></file-button>
      </div>

      <el-table
        size="mini"
        :data="serviceQuestComments"
        v-loading="loading"
        v-if="!isMobile()"
      >
        <el-table-column label="NCR / SO">
          <template slot-scope="scope">
            <div>{{ scope.row.service_quest.number }}</div>
            <div class="text-gray">
              {{ scope.row.service_quest.service_order_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户 / 设备" min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.service_quest.customer.name }}</div>
            <div>
              {{ scope.row.service_quest.device.serial_number
              }}<span v-if="scope.row.service_quest.device.equipment_number"
                >（{{ scope.row.service_quest.device.equipment_number }}）</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="短信发送时间" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template></el-table-column
        >
        <el-table-column label="是否评价" align="center">
          <template slot-scope="scope">
            <template>{{ scope.row.comment_info ? '是' : '否' }} </template>
          </template></el-table-column
        >
        <el-table-column label="工程师" align="center" prop="user_name">
        </el-table-column>
        <el-table-column label="总体评分" align="center">
          <template slot-scope="scope">
            <template
              >{{
                scope.row.comment_info
                  ? scope.row.comment_info.rate + '星'
                  : '-'
              }}
            </template>
          </template></el-table-column
        >
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <!-- <el-button
              v-if="scope.row.sms_records.length == 0"
              type="primary"
              plain
              size="mini"
              @click="showContacts(scope.row, scope.$index)"
              >发送短信</el-button
            > -->
            <el-button
              v-if="scope.row.comment_info"
              type="primary"
              plain
              size="mini"
              @click="showComment(scope.row)"
              >评价详情</el-button
            >
          </template></el-table-column
        >
      </el-table>
      <div class="mt-20">
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <CustomerContacts
      :show.sync="contactsVisible"
      :customerID="customerID"
      :serviceQuestID="serviceQuestID"
      @sended="requestServiceQuest"
    ></CustomerContacts>

    <CommentDetail
      :show.sync="conmentVisible"
      :comment="comment"
    ></CommentDetail>
  </div>
</template>

<script>
import { serviceQuestCommentList } from '../../service/getData'
import CustomerSelect from '@/components/select/customer_select'
import { formatTime, isMobile } from '@/util/index'
import { ServiceQuestStatusMap, ServiceQuestModeStatus } from '@/config/global'
import CustomerContacts from './customer_contacts'
import CommentDetail from './comment_detail'

const resetFilter = {
  customer_id: '',
  number: '',
  service_order_number: '',
  date: '',
  page: 1,
  size: 20,
  is_comment: 0,
}

export default {
  components: {
    CustomerSelect,
    CustomerContacts,
    CommentDetail,
  },
  data() {
    return {
      formatTime,
      isMobile,
      ServiceQuestStatusMap,
      ServiceQuestModeStatus,
      serviceQuestComments: [],
      filter: this.clone(resetFilter),
      total: 0,
      contactsVisible: false,
      customerID: 0,
      serviceQuestID: 0,
      comment: {},
      conmentVisible: false,
    }
  },
  watch: {
    'filter.page': function () {
      this.requestServiceQuest()
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }

    this.requestServiceQuest()
  },
  methods: {
    async requestServiceQuest() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      this.loading = true
      let query = Object.assign({}, this.filter)
      query.page = query.page - 1

      if (query.date && query.date.length == 2) {
        query.start_date = query.date[0] || ''
        query.end_date = query.date[1] || ''
      }

      if (!query.customer_id) {
        query.customer_id = 0
      }

      let res = await serviceQuestCommentList(query)
      if (res.code == 0) {
        this.serviceQuestComments = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    reset() {
      this.filter = this.clone(resetFilter)
      this.requestServiceQuest()
    },
    showContacts(item, index) {
      this.customerID = item.customer_id
      this.serviceQuestID = item.id
      this.contactsVisible = true
    },

    showComment(item) {
      this.comment = item.comment_info
      this.conmentVisible = true
    },
  },
}
</script>